import React from "react";
import { Link, useRouteMatch } from "react-router-dom";

import { Skeleton, Tooltip } from "components";
import { useLoader } from "hooks";
import { NavigationItemType } from "types";

import styles from "./mainNavigationInfo.module.scss";

type NavigationItemProps = {
	loading: boolean;
	item: NavigationItemType;
};

const NavigationItem = ({ loading, item }: NavigationItemProps) => {
	const { isLoading = true } = item;

	const Loader = useLoader(isLoading && loading);
	const { url: currentUrl } = useRouteMatch();
	const isMatchCurrentUrl = item.path?.includes(currentUrl);

	const getHref = () => {
		if (item.guard) {
			const shouldNavigate = item.guard();
			if (!shouldNavigate) return undefined;
		}

		return item.path && !isMatchCurrentUrl ? item.path : undefined;
	};

	const href = getHref();

	return (
		<div className={styles.dataHolder}>
			<p className={`${styles.dataTitle} ${item?.labelClassName || ""}`}>
				{item.label}:
			</p>
			<Loader
				skeleton={
					<Skeleton
						variant="text"
						height="20px"
						width="100px"
						maxWidth="150px"
					/>
				}
				component={
					<Tooltip title={item?.tooltip}>
						{href ? (
							<Link to={href} target="_blank">
								{item.data ?? "-"}
							</Link>
						) : (
							item.data ?? "-"
						)}
					</Tooltip>
				}
			/>
		</div>
	);
};

export default NavigationItem;
